export enum License {
	silver = 'silver',
	gold = 'gold',
	bronze = 'bronze',
}
